//Creates Initial for user icon, defaults to profile outline.
document.addEventListener("DOMContentLoaded", () => {
    const avatar = document.querySelector('.js--element-userAvatarImage')
    if (!avatar) {
        return;
    }
    
    const printPointAccountNav = document.querySelector('.userAccount-aside-nav-item_printPoints')

    Collaterate.User.getUser()
        .then(user => {
            
            //set user icon
            avatar.innerHTML = `${user.firstName.slice(0,1).toUpperCase()}`
        
            if (user.loyalty) {
                printPointAccountNav && document.querySelector('body').classList.add(`navPPColor_${user.loyalty.name.toLowerCase()}`)
            } 
            
        })
        .catch(() => {
            avatar.innerHTML = `<img src="https://spdc-assets.imgix.net/images/gravatar.png" alt="User Profile"/>`
        })
});